import { number, object, string } from "yup";
import { PASSWORD_RULE } from "./signupValidationSchema";

export const depositLimitsValidationSchema = object().shape({
    period: string().when("$configObj", ([config], schema) => {
        return schema.required(config.t("validation_err_required"));
    }),
    password: PASSWORD_RULE,
    amount: number().when("$configObj", ([config], schema) => {
        return schema
            .positive(config.t("validation_err_positive"))
            .typeError(config.t("validation_err_notValid"))
            .required(config.t("validation_err_required"));
    }),
});
